import { render, staticRenderFns } from "./smartConfig.vue?vue&type=template&id=37b1d294&scoped=true"
import script from "./smartConfig.vue?vue&type=script&lang=js"
export * from "./smartConfig.vue?vue&type=script&lang=js"
import style0 from "./smartConfig.vue?vue&type=style&index=0&id=37b1d294&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b1d294",
  null
  
)

export default component.exports